import React, { useEffect, useState } from 'react'
import LocationService from '../api/Participantes/api.location'
import { Pais, Departamentos,  Comunas } from '../models/LocationsModels/locations.models'

export const useLocations = () => {

    const [paises, setPaises] = useState<Pais[]>([]);
    const obtenerPaises = async () => {
        try {
            const paises = await LocationService.obtenerPaises();
            return setPaises(paises);
        } catch (error) {
            console.log(error)
        }
    }

    const [departamentos, setDepartamentos] = useState<Departamentos[]>([])
    const obtenerDepartamentos = async () => {
        try {
            const departamentos = await LocationService.obtenerDepartamentos();
            const departamentosFilter = departamentos.filter((x) => x.nombre !== 'OTRAS'); 
            setDepartamentos(departamentosFilter);
        } catch (error) {
            console.log(error)
        }
    }

    const [comunas, setComunas] = useState<Comunas[]>([]);
    const obtenerComunas = async () => {
        try {
            const comunas = await LocationService.obtenerComunas();
            setComunas(comunas);
        } catch (error) {
            console.log(error)
        }
    }


    


    useEffect(() => {
        let mounted = true;
        if (mounted) {
            obtenerPaises();
            obtenerDepartamentos();
            obtenerComunas();
        }
        return () => {
            mounted = false;
        }
    }, [])


    return {
        paises,
        departamentos,
        comunas
    }


}
